<template>
    <div class="help-document">
        <div class="doc-panel ui-ctrl ui-panel">
            <div class="markdown">
                <usage-view v-if="showUsage"/>
                <account-view v-if="showAccount"/>
                <connect-view v-if="showConnect"/>
                <template-view v-if="showTemplate"/>
                <introduction-view v-if="showIntroduce"/>
            </div>
        </div>
        <div class="doc-nav">
            <ul class="doc-toc">
                <li :key="index" v-for="(item, index) in tocDataSource">
                    <a :title="item.text" @click="handleRedirect(item)">{{item.text}}</a>
                    <ul v-if="item.items && item.items.length">
                        <li :key="index" v-for="(ele,index) in item.items">
                            <a :title="ele.text" @click="handleRedirect(ele)">{{ele.text}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

import {assign} from 'lodash';
import UsageView from './docs/usage.md';
import AccountView from './docs/account.md';
import ConnectView from './docs/connect.md';
import TemplateView from './docs/template.md';
import IntroduceView from './docs/introduce.md';

export default {

    name: 'DocWrapper',
    components: {
        'usage-view': UsageView,
        'account-view': AccountView,
        'connect-view': ConnectView,
        'template-view': TemplateView,
        'introduction-view': IntroduceView
    },
    mounted() {
        const hash = this.$route.hash;
        if (hash) {
            // 需要放在 nextTick 里做， 否则滚动的地方不对
            this.$nextTick(() => {
                this.scrollToAnchor(hash.slice(1), 80);
            });
        }
    },
    methods: {
        handleRedirect(item) {
            this.scrollToAnchor(item.seg, 80);
            this.$router.push(assign({}, this.$route, {
                hash: item.seg
            }));
        },
        scrollToAnchor(id, offset) {
            // 需要把 header 的高度减掉
            const filedTop = document.getElementById(id).getBoundingClientRect().top - offset;
            const top = parseInt(document.documentElement.scrollTop + filedTop, 10);

            window.scroll(0, top);
        }
    },
    computed: {
        showUsage() {
            return this.$route.params.current === 'usage';
        },
        showAccount() {
            return this.$route.params.current === 'account';
        },
        showConnect() {
            return this.$route.params.current === 'connect';
        },
        showTemplate() {
            return this.$route.params.current === 'template';
        },
        showIntroduce() {
            return this.$route.params.current === 'introduce';
        },
        tocDataSource() {
            return this[this.$route.params.current];
        }
    },
    data() {
        return {
            usage: [
                {
                    text: '4.1 开放平台功能介绍',
                    seg: '4.1'
                },
                {
                    text: '4.2 平台操作流程及详解',
                    seg: '4.2',
                    items: [
                        {
                            text: '操作流程图',
                            seg: '4.2.1'
                        },
                        {
                            text: '操作流程详解',
                            seg: '4.2.2'
                        }
                    ]
                },
                {
                    text: '4.3 服务功能介绍',
                    seg: '4.3',
                    items: [
                        {
                            text: '地图服务',
                            seg: '4.3.1'
                        },
                        {
                            text: '投票服务',
                            seg: '4.3.2'
                        },
                        {
                            text: '表单服务',
                            seg: '4.3.3'
                        },
                        {
                            text: '微博服务',
                            seg: '4.3.4'
                        },
                        {
                            text: '领券服务',
                            seg: '4.3.5'
                        },
                        {
                            text: '自定义API服务',
                            seg: '4.3.6'
                        }
                    ]
                },
                {
                    text: '4.4 卡片功能介绍',
                    seg: '4.4',
                    items: [
                        {
                            text: '卡片管理操作流程',
                            seg: '4.4.1'
                        },
                        {
                            text: '卡片管理列表',
                            seg: '4.4.2'
                        },
                        {
                            text: '新建卡片',
                            seg: '4.4.3'
                        },
                        {
                            text: '编辑卡片',
                            seg: '4.4.4'
                        },
                        {
                            text: '保存草稿',
                            seg: '4.4.5'
                        },
                        {
                            text: '提交预览',
                            seg: '4.4.6'
                        },
                        {
                            text: '取消卡片配置',
                            seg: '4.4.7'
                        },
                        {
                            text: '卡片预览',
                            seg: '4.4.8'
                        },
                        {
                            text: '查看卡片',
                            seg: '4.4.9'
                        }
                    ]
                },
                {
                    text: '4.5 组件功能介绍',
                    seg: '4.5',
                    items: [
                        {
                            text: '组件管理操作流程',
                            seg: '4.5.1'
                        },
                        {
                            text: '组件管理列表',
                            seg: '4.5.2'
                        },
                        {
                            text: '新建组件',
                            seg: '4.5.3'
                        },
                        {
                            text: '组件编辑',
                            seg: '4.5.4'
                        },
                        {
                            text: '刷新预览',
                            seg: '4.5.5'
                        },
                        {
                            text: '保存草稿',
                            seg: '4.5.6'
                        },
                        {
                            text: '提交审核',
                            seg: '4.5.7'
                        },
                        {
                            text: '取消组件编辑',
                            seg: '4.5.8'
                        },
                        {
                            text: '查看组件页',
                            seg: '4.5.9'
                        },
                        {
                            text: '组件更新维护',
                            seg: '4.5.10'
                        }
                    ]
                },
                {
                    text: '4.6 中间页功能介绍',
                    seg: '4.6',
                    items: [
                        {
                            text: '中间页操作流程',
                            seg: '4.6.1'
                        },
                        {
                            text: '中间页管理列表',
                            seg: '4.6.2'
                        },
                        {
                            text: '新建中间页',
                            seg: '4.6.3'
                        },
                        {
                            text: '编辑中间页',
                            seg: '4.6.4'
                        },
                        {
                            text: '中间页提交预览页',
                            seg: '4.6.5'
                        },
                        {
                            text: '查看中间页',
                            seg: '4.6.6'
                        }
                    ]
                }
            ],
            account: [
                {
                    text: '3.1 账号信息修改',
                    seg: '3.1'
                },
                {
                    text: '3.2 代理商资质修改',
                    seg: '3.2'
                },
                {
                    text: '3.3 找回密码',
                    seg: '3.3'
                },
                {
                    text: '3.4 修改密码',
                    seg: '3.4'
                },
                {
                    text: '3.5 登陆锁定',
                    seg: '3.5'
                }
            ],
            connect: [
                {
                    text: '2.1 服务商注册新用户',
                    seg: '2.1'
                },
                {
                    text: '2.2 服务商资质认证',
                    seg: '2.2'
                }
            ],
            introduce: [
                {
                    text: '1.1 什么是品牌营销开放平台',
                    seg: '1.1'
                },
                {
                    text: '1.2 服务品专可以为广告主、为用户、为代理商带来什么？',
                    seg: '1.2'
                }
            ],
            template: [
                {
                    text: '5.1 新建模板并发布成固定样式的流程',
                    seg: '5.1'
                },
                {
                    text: '5.2 列表页',
                    seg: '5.2',
                    items: [
                        {
                            text: '5.2.1 新建模板',
                            seg: '5.2.1'
                        },
                        {
                            text: '5.2.2 编辑模板',
                            seg: '5.2.2'
                        },
                        {
                            text: '5.2.3 调整标签',
                            seg: '5.2.3'
                        },
                        {
                            text: '5.2.4 查看',
                            seg: '5.2.4'
                        },
                        {
                            text: '5.2.5 发布到素材库',
                            seg: '5.2.5'
                        },
                        {
                            text: '5.2.6 禁用',
                            seg: '5.2.6'
                        },
                        {
                            text: '5.2.7 删除',
                            seg: '5.2.7'
                        }
                    ]
                },
                {
                    text: '5.3 新建样式',
                    seg: '5.3',
                    items: [
                        {
                            text: '5.3.1 新建标准样式',
                            seg: '5.3.1'
                        },
                        {
                            text: '5.3.2 新建创新样式',
                            seg: '5.3.2'
                        },
                        {
                            text: '5.3.3 组件间距选择',
                            seg: '5.3.3'
                        },
                        {
                            text: '5.3.4 actionLinks的配置',
                            seg: '5.3.4'
                        }
                    ]
                }
            ]
        };
    }
};
</script>
<style lang="less">
@import '../css/variables.less';
.ria-sidebar .nav-item-row-label {
    max-width: 160px;
}
.help-document {
    @import "../css/markdown.less";

    h1, h2, h3, h4, h5, h6 {
        color: @muses-heading-color;
    }

    .markdown {
        h2 {
            font-size: 1.55em;
        }
        h3 {
            font-size: 1.4em;
        }
        h4 {
            font-size: 1.2em;
        }
        h2,
        h3,
        h4 {
            &::before {
                content: "";
                display: block;
                height: 1em;
                margin-top: -1em;
            }
        }
    }

    .ui-panel {
        margin-right: 210px;
    }

    .doc-nav {
        position: fixed;
        right: 30px;
        top: 100px;
        box-sizing: border-box;
        width: 210px;
        box-shadow: 0 0 4px @muses-aux-color;
        line-height: 28px;
        border-radius: 2px;
        &::before {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            width: ~"calc(100% + 2px)";
            height: 2px;
            background: @muses-primary-blue;
            border-radius: 2px 2px 0 0;
        }
    }

    .doc-toc {
        max-height: 500px;
        overflow: auto;
        margin: 0;
        padding: 10px 20px;

        &,
        ul {
            list-style: none;
        }

        ul {
            margin: 0;
            padding-left: 30px;
        }

        a {
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            padding: 0;
        }
    }

    .emphasize {
        color: #f00;
    }
}
</style>


